import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface CurrencySetDefaultParams {
    readonly id: number;
}

export type CurrencySetDefaultResponse = {
    value: number,
    version: string
}[];

export class CurrencySetDefaultCommand extends Command<CurrencySetDefaultParams, CurrencySetDefaultResponse> { }

export class CurrencySetDefaultCommandHandlerBase implements CommandHandler<CurrencySetDefaultCommand, CurrencySetDefaultParams, CurrencySetDefaultResponse> {
    private static Url = TaggedUrl.join('system/currencies/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: CurrencySetDefaultCommand): Promise<CurrencySetDefaultResponse> {
        const { data } = await this.http.put(fillPlaceholders(CurrencySetDefaultCommandHandlerBase.Url, { id: command.params?.id }));

        return data;
    }
}
